const { makeEvent } = require('./event')

module.exports = {
  makeEvent
}